import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { environment } from '../../../../../environments/environment';
import { AuthModel } from '../../_models/auth.model';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EnvService } from 'src/app/service/env.service';

// const API_USERS_URL = `${this.environment.apiUrl}/Auth`;

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  API_USERS_URL = `${this.environment.apiUrl}/Auth`;

  constructor(private http: HttpClient,private spinner: NgxSpinnerService,
    private translationService: TranslationService,private environment : EnvService) { }

    Header() {
      var UserToken:any = JSON.parse(localStorage.getItem("v1Balsam-authf649ei9a5f55"));
      let header = new HttpHeaders().set("Authorization","Bearer " + UserToken?.token).set("Accept-Language", this.translationService.getSelectedLanguage());
      const options = {
        headers: header,
      };
      return options;
    }

  // public methods
  login(passportNo: string, password: string,isWeb:boolean = true): Observable<any> {
    return this.http.post<AuthModel>(`${this.API_USERS_URL}/Login`, { passportNo, password,isWeb },this.Header());
  }
  Stafflogin(personalNo: string, password: string,isWeb:boolean = true): Observable<any> {
    return this.http.post<AuthModel>(`${this.API_USERS_URL}/StaffLogin`, { personalNo, password,isWeb },this.Header());
  }
  ForgetPassword(PassportNo: string, Mobile): Observable<any> {
    return this.http.get<AuthModel>(`${this.API_USERS_URL}/ForgetPassword?PassportNo=`+PassportNo+'&Mobile='+Mobile,this.Header());
  }
  ValidateOtp(PassportNo: string,Otp: string, SecretKey:string): Observable<any> {
    return this.http.get<AuthModel>(`${this.API_USERS_URL}/ValidateOtp?PassportNo=`+PassportNo+'&Otp='+Otp+'&SecretKey='+SecretKey,this.Header());
  }
  ResetPassword(PatientId, GuestId,NewPassword,SecretKey): Observable<any> {
    return this.http.post<AuthModel>(`${this.API_USERS_URL}/ResetPassword?PatientId=`+PatientId+'&GuestId='+GuestId+'&NewPassword='+NewPassword+'&SecretKey='+SecretKey,null,this.Header());
  }
  SendOtpForPatient(PassportNo: string, Mobile): Observable<any> {
    return this.http.get<AuthModel>(`${this.API_USERS_URL}/SendOtpForPatient?PassportNo=`+PassportNo+'&Mobile='+Mobile,this.Header());
  }
  CheckPatientDataAndSendOTP(PassportNo: string, Mobile): Observable<any> {
    return this.http.get<AuthModel>(`${this.environment.apiUrl}/Family/CheckPatientDataAndSendOTP?PassportNo=`+PassportNo+'&Mobile='+Mobile,this.Header());
  }
  SendOtpForGuest(PassportNo: string, Mobile): Observable<any> {
    return this.http.get<AuthModel>(`${this.API_USERS_URL}/SendOtpForGuest?PassportNo=`+PassportNo+'&Mobile='+Mobile,this.Header());
  }
  ChangePassword(TokenRequestModel): Observable<any> {
    return this.http.post<AuthModel>(`${this.API_USERS_URL}/ChangePassword`, TokenRequestModel,this.Header());
  }
  ChangePasswordForStaff(TokenRequestModel): Observable<any> {
    return this.http.post<AuthModel>(`${this.API_USERS_URL}/ChangePasswordForStaff`, TokenRequestModel,this.Header());
  }
  DeleteAccount(): Observable<any> {
    return this.http.post<AuthModel>(`${this.API_USERS_URL}/DeleteAccount`,null,this.Header());
  }
  RefreshToken(PatientId: number, GuestId : number,RefreshToken:string): Observable<any> {
    return this.http.get<AuthModel>(`${this.API_USERS_URL}/refreshToken?PatientId=`+PatientId+'&GuestId='+GuestId+'&RefreshToken='+RefreshToken,this.Header());
  }
  SwitchFamilyMember(MemberId): Observable<any> {
    return this.http.post<any>(`${this.environment.apiUrl}/Family/SwitchFamilyMember?MemberId=`+MemberId,null,this.Header());
  }
  // ForgetPassword(PatientId: number, Password: string): Observable<any> {
  //   return this.http.post<AuthModel>(`${API_USERS_URL}/ForgetPassword?PatientId=`+PatientId+'&Password='+Password,null,this.Header());
  // }
  CreateNewAccount(PassportNumber,Mobile,Password,SecretKey): Observable<any> {
    return this.http.post<AuthModel>(`${this.API_USERS_URL}/CreateNewAccount?PassportNumber=`+PassportNumber+'&Mobile='+Mobile+'&Password='+Password+'&SecretKey='+SecretKey,null,this.Header());
  }
  CreateNewAccountForGuest(apiGuestInfoModel): Observable<any> {
    return this.http.post<any>(`${this.API_USERS_URL}/CreateNewAccountForGuest`,apiGuestInfoModel,this.Header());
  }
  showLoader() {
    this.spinner.show();
  }
  hideLoader() {
    this.spinner.hide();
  }
}
